import React, { useEffect, useRef, useState } from "react";
import CytoscapeComponent from "react-cytoscapejs";
import cytoscape from "cytoscape";
import elk from "cytoscape-dagre";
import cyHtmlLabel from "cytoscape-node-html-label";
import '../assets/css/graph.css';
import expand_arrow from "../assets/images/expand_arrow.svg"
import expand_arrow_up from "../assets/images/expand_arrow_up.svg"
import neighbour from "../assets/images/arrow_back.svg"
import link_external from "../assets/images/external_link.svg"
import link_internal from "../assets/images/internal_link.svg"
import hide from "../assets/images/hide.svg"
import { showTooltip, hideTooltip } from "../components/widget/Tooltip";

cytoscape.use( elk );
cytoscape.use(cyHtmlLabel);


const Graph = ({ vertices, edges, parentedVerteces, get_connected_nodes, hide_subtree, get_node_info_detailed, reset_nodeinfo}) => {
  const cyRef = useRef(null);
  const spacing = 100; // Distance between nodes
  const fixedValue = 100; // Keep y constant for a horizontal layout

  /*SORTING: vertices.forEach((item, index) => {
    item["position"] = { x: index * spacing, y: fixedValue }; // Assign position
  });*/

  const elements = [...vertices, ...edges]

  // Extract unique tree types
  const treeTypes = [...new Set(vertices.map((node) => node.data.tree))];

  // Generate color mapping for each tree type
  const treeColors = {};
  const colorPalette = [
    ["#E298A6", "#DB7B8E", "#D45E76", "#CE405D"], // Pink
    ["#A0BAEE", "#81A4E9", "#628DE4", "#4277E0"], // Blue
    ["#A8DA58", "#99D539", "#87C328", "#73A621"], // Green
    ["#EDB682", "#EAA362", "#E69141", "#E47F21"], // Orange
    ["#66CCC0", "#4AC4B6", "#38B2A4", "#2F988C"], // Teal
    ["#8D4BD2", "#7A31C9", "#6929AE", "#572191"], // Purple
    ["#F2712C", "#EC5C0E", "#CB4E0B", "#AA4108"], // Orange
    ["#C4E67A", "#B7E15B", "#AADD3C", "#9AD123"]  // Green
  ];
  treeTypes.forEach((tree, index) => {
    treeColors[tree] = colorPalette[index % colorPalette.length]; // Cycle colors if needed
  });

  // Extract levels for nodes
  const levels = {};
  
  edges.forEach((edge) => {
    const { source, target, label_from, label_to } = edge.data;

    if (!(source in levels)) {
      levels[source] = label_from;
    }
    if (!(target in levels)) {
      levels[target] = label_to;
    }
  });

  

  //const parentedVerteces = edges //Vertices where the children are showing
    //.filter(edge => !edge.classes.includes("cross-link")) // Exclude cross-link edges
    //.map(edge => edge.data.target);

  // DAGRE LAYOUT:
  const layout = {
    name: "dagre",
    nodeSep: 50, // Spacing between nodes
    rankSep: 100, // Spacing between layers
    rankDir: "TB", // Top-to-bottom layout (Use "LR" for left-to-right)
    align: "UL", // Aligns nodes similarly to the input order
    spacingFactor: 1.2,
  };

  // KLAY LAYOUT:
  /*const layout = {
    name: "klay",
    klay: {
      direction: "DOWN",
      thoroughness: 10 
    },
    ranker: "network-simplex", // Algorithm for node ranking ("tight-tree", "longest-path", etc.)
    directed: true,
    spacingFactor: 1.5,
    padding: 10,
    avoidOverlap: true,
    grid: false,
    animate: true,
    fit: true,
    roots: Object.keys(levels).filter((key) => levels[key] === 1), // Nodes at level 1 as roots
  };*/

  const stylesheet = [
    {
      selector: "node.node",
      style:{
        label: "data(label)",
        backgroundColor: "white",
        margin: "5px",
        "border-style": "solid",
        width: "38px",
        height: "38px",
        "font-family": "Nokia Pure Regular",
        "background-opacity": "1",
        "text-margin-y": "-5px",

      }
    },
    {
      selector: "node.standardNode",
      style: {
        "shape": "ellipse",
        "border-width": "10px",
      }
    },
    {
      selector: "node.leafNode",
      style: {
        width: "45px",
        "shape": "round-triangle",
        "border-width": "10px",
        
      }
    },
    {
      selector: "node.rootNode",
      style: {
      
        "shape": "round-diamond",
        "border-width": "10px",
        
      }
    },
    {
      selector: "node.node:selected",
      style: {
        "border-color": "black", /* Keep the existing border */
        "border-width": "10px",  /* Ensure the inner border remains */
    
        "outline-color": "#6BA2F0", /* Add the blue outer border */
        "outline-width": "2px",  /* Control thickness of the outer border */
        "outline-offset": "5px"  /* Creates the whitespace between the borders */
      }
    },
    
    {
      selector: "node.standardNode",
      style: {
        
      },
    },
    {
      selector: "edge",
      style: {
        width: 2,
        targetArrowShape: "triangle",
        curveStyle: "bezier",
        
      },
    },
    {
      selector: "edge.hover",
      style: {
        "line-color": "lightgray"
      },
    },
    
    { selector: ".cross-link", style: {width:2, "line-style": "dashed", "opacity":0.9, "target-arrow-shape": "triangle" } },
    { selector: ".cross-link.internal", style: {"line-color": "#D23B59", "target-arrow-shape": "triangle", "target-arrow-color": "#D23B59" } },
    { selector: ".cross-link.external", style: {"line-color": "#4479E0", "target-arrow-shape": "triangle", "target-arrow-color": "#4479E0" } },
    {
      selector: ".cross-link.hover",
      style: {
        "opacity":0.4
      },
    },
    
    { selector: ".tree", style: 
     {
      backgroundColor: "white", 
      width: 0,  
      height: 0,
      label: "",
      events: "no"
  } },
    // Apply a different color to nodes based on the "tree" property
    ...treeTypes.flatMap((tree) => [
      {
        selector: `node[tree='${tree}'].node`,
        style: {
          "border-color": treeColors[tree][3],
        },
      },
      {
        selector: `node[tree='${tree}'].node.hover`,
        style: {
          "border-color": treeColors[tree][2],
        },
      },
    ]),
    
  ];

  useEffect(() => {
    if (!cyRef.current) return;
    const cy = cytoscape({
      container: cyRef.current,
      elements: elements,
      style: stylesheet,
    });

    layout.eles = cy.elements().difference(cy.edges('.internal'))

    cy.layout(layout).run();


    cy.on("mouseover", ".node", function (e) {
      e.target.addClass("hover");
      cy.container().style.cursor = 'pointer';
      showTooltip(e.target["_private"]["data"]["title"]) 
    });
    
    cy.on("mouseout", ".node", function (e) {
      e.target.removeClass("hover");
      cy.container().style.cursor = '';
      hideTooltip() 

    });

    cy.on("mouseover", "edge", function (e) {
      e.target.addClass("hover");
      let tooltip_txt = e.target["_private"]["data"]["name_from"] + " -> " + e.target["_private"]["data"]["name_to"]
      showTooltip(tooltip_txt) 
    });
    
    cy.on("mouseout", "edge", function (e) {
      e.target.removeClass("hover");
      hideTooltip() 
    });
    
    
    cy.on("mousedown", ".node", function (e) {
      e.target.addClass("hover");
    });
    
    cy.on("click", "node.node", function (e) {
      //console.log("clicked:");
      get_node_info_detailed(this["_private"]["data"]["name"])
    });

    cy.on('tap', function(event) {
      //console.log(event.target)
      if (event.target === cy) {
        //Remove selected node if clicking anywhere on a graph that is not a node
        reset_nodeinfo();
      }
  });

    //cy.autounselectify( true );

    /*cy.on("tap", ".tree", function (e) {
      console.log(e)
      e.preventDefault();
      e.stopPropagation();
    });*/
    
    //EDGES EVENTS
    cy.on("mouseover", "edge", function (e) {
      e.target.addClass("hover");
    });
    cy.on("mouseout", "edge", function (e) {
      e.target.removeClass("hover");
    });

    const showChildren = (event, nodeId) => {
      get_connected_nodes(nodeId, "child")
      event.preventDefault();
      event.stopPropagation();
      console.log("show children!");
    };    

    const showNeighbours = (nodeId, reference="ref") => {
      get_connected_nodes(nodeId, reference)
      console.log("show external_ref!");
    };

    const showParent = (nodeId) => {
      get_connected_nodes(nodeId, "parent")
    }

    const hideSubtree = (nodeId) => {
      console.log("hide subtree")
      hide_subtree(nodeId);
    };

    const nodeIsParanted = (node) => {
      return parentedVerteces.some(v => v.toString() === node.id.toString()) || node.label === node.name //Parent is showing or is a root
    }

    cy.nodes().forEach(node => {
      const data = node.data();
      if (node.classes().includes("node")) {
        // Check if the node is paranted and update the label accordingly
        const newLabel = nodeIsParanted(data) ? data.label : data.name;
          
        node.style("label", newLabel);
      }
      
      
    });


    cy.nodeHtmlLabel([
      {
        query: ".tree",
        halign: "center",
        valign: "bottom",
        tpl: (data) => `<div class="tree_label" ><span class="font-small semibold">${data.title}<span/></div>`
      },
      {
        query: "node.node",
        halign: "center",
        valign: "center",
        tpl: (data) => `<div data-id="${data.id}" data-root="${data.tree}" class="nodeOuter standardNode flex-column">
        <div class="flex-row" style="min-height: 20px">
        ${data.hasExternalNeighbour ? `<div class="hasNeighbourIconOuter"><span class="hasNeighbourIcon external-icon" "><img class="node-button-img large" src="${link_external}"/></span></div>` : ``}
        ${data.hasInternalNeighbour ? `<div class="hasNeighbourIconOuter"><span class="hasNeighbourIcon internal-icon" "><img class="node-button-img large" src="${link_internal}"/></span></div>` : ``}
        </div>
        
        <span class="standardNode-outer">
        </span>
        <div class="node-button-panel-outer"><div class="node-button-panel-inner flex-row">
        ${!nodeIsParanted(data) ? `<div role="button" class="node-button expand_up"><img class="node-button-img" src="${expand_arrow_up}"/></div>` : ``}
        ${!data.isLeaf ? `<div role="button" class="node-button expand_down"><img class="node-button-img" src="${expand_arrow}"/></div>` : ``}
        ${data.hasExternalNeighbour ? `<div role="button" class="node-button external"><img class="node-button-img" src="${link_external}"/></div>` : "" }
        ${data.hasInternalNeighbour ? `<div role="button" class="node-button internal"><img class="node-button-img" src="${link_internal}"/></div>` : "" }

        <div role="button" class="node-button hide"><img class="node-button-img" src="${hide}"/></div>
        </div></div>
        
        
      </div>`
      },
    ], {
      enablePointerEvents: true,
    });

    cy.on("tap", (event) => {
      //event.preventDefault();
      //event.stopPropagation();
    });

    



  

    
  
  

    cy.nodes().on("tap", (event) => {
      //event.preventDefault();
      //event.stopPropagation();
    });
    

    document.addEventListener("click", (event) => {
      /*if (event.target.closest(".node-button-panel-inner")) {
        // Stop the event from propagating to Cytoscape nodes
        event.stopPropagation();
    }*/

      const button = event.target.closest(".node-button");
      if (!button) return; // Ignore clicks outside buttons
  
      const node = button.closest(".nodeOuter");
      if (!node) return; // Ignore clicks outside nodes
  
      const dataId = node.getAttribute("data-id");
      console.log("Button clicked: ", button.classList, "Node ID: ", dataId);
  
      if (button.classList.contains("expand_down")) {
          showChildren(event, dataId);
      } else if (button.classList.contains("external")) {
          showNeighbours(dataId, "external_ref");
      } else if (button.classList.contains("internal")) {
        showNeighbours(dataId, "internal_ref");
      } else if (button.classList.contains("hide")) {
          hideSubtree(dataId);
      } else if (button.classList.contains("expand_up")) {
          showParent(dataId);
      }
  });


    /*const handleMouseOver = (event) => {
        if (event.target.closest(".node-button-panel-outer")) {
          cy.elements(".tree").style("events", "no"); // Change to desired color


        }
    };

    // Function to handle mouseout event
    const handleMouseOut = (event) => {
        if (event.target.closest(".node-button-panel-outer")) {
          cy.elements(".tree").style("events", "yes"); // Change to desired color
        }
    };

    // Attach event listeners to the document (event delegation)
    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);*/
   
  

    

    return () => {
      cy.destroy();
      //document.removeEventListener("mouseover", handleMouseOver);
      //document.removeEventListener("mouseout", handleMouseOut);
    };
  }, [elements, stylesheet, layout]);



  return <div ref={cyRef} className="cy-graph" style={{ width: "100%", height: "100%" }}></div>;
};

export default Graph;


/*
const cyRef = useRef(null);

  const elements = [
    // Tree 1
    { data: { id: "A", label: "A" } },
    { data: { id: "B", label: "B", parent: "A" } },
    { data: { id: "C", label: "C", parent: "A" } },
    { data: { id: "D", label: "D", parent: "B" } },
    { data: { id: "E", label: "E", parent: "B" } },
    
    { data: { id: "AB", source: "A", target: "B" } },
    { data: { id: "AC", source: "A", target: "C" } },
    { data: { id: "BD", source: "B", target: "D" } },
    { data: { id: "BE", source: "B", target: "E" } },
    
    // Tree 2
    { data: { id: "X", label: "X" } },
    { data: { id: "Y", label: "Y", parent: "X" } },
    { data: { id: "Z", label: "Z", parent: "X" } },
    { data: { id: "XY", source: "X", target: "Y" } },
    { data: { id: "XZ", source: "X", target: "Z" } },
    
    // Cross-tree connection
    { data: { id: "EX", source: "E", target: "X" }, classes: "cross-link" }
  ];

  const layout = {
    name: "dagre",
    rankDir: "TB",
  };

  const styleSheet = [
    { selector: "node", style: { "background-color": "#3498db", "label": "data(label)", "text-valign": "center", "color": "white" } },
    { selector: "edge", style: { "width": 2, "line-color": "#2ecc71", "curve-style": "bezier" } },
    { selector: ".cross-link", style: { "line-style": "dashed", "line-color": "#e74c3c", "target-arrow-shape": "triangle" } }
  ];

  return (
    <CytoscapeComponent
      elements={elements}
      style={{ width: "100%", height: "500px" }}
      layout={layout}
      stylesheet={styleSheet}
      cy={(cy) => (cyRef.current = cy)}
    />
  );
};

*/